/**
 * Created by razial on 14.02.2025.
 */

const LivesHelper = {
    initialized: false,

    main: undefined,

    Initialize: function (isNewUser) {
        this.initialized = true;

        const locationConfig = cleverapps.meta.getLocationMeta(cleverapps.meta.getMainLocationId()).locationConfig;
        this.main = new cleverapps.Lives(locationConfig);
        this.main.load();
        this.main.processRegenerateState();

        if (isNewUser) {
            this.main.reset();
        }

        cleverapps.lives = this.main;
    },

    Switch: function (locationId) {
        if (!this.initialized) {
            return;
        }

        if (cleverapps.lives !== this.main) {
            cleverapps.lives.destructor();
        }

        const locationMeta = cleverapps.meta.getLocationMeta(locationId);
        const locationConfig = locationMeta.locationConfig;

        if (locationConfig.withOwnLives) {
            cleverapps.lives = new cleverapps.Lives(locationConfig);
            cleverapps.lives.load();
            cleverapps.lives.processRegenerateState();
        } else {
            cleverapps.lives = this.main;
        }

        cleverapps.pendingRewards.release("lives");
    },

    GetMainInstance: function () {
        return this.main;
    },

    GetTmpInstance: function (locationId) {
        const locationMeta = cleverapps.meta.getLocationMeta(locationId);
        const locationConfig = locationMeta.locationConfig;

        if (!locationConfig.withOwnLives) {
            return this.main;
        }

        const instance = new cleverapps.Lives(locationConfig);
        instance.save = function () {

        };
        instance.load();
        instance.processRegenerateState();
        instance.stopRegenerateTimeout();

        return instance;
    },

    GiveTo: function (locationId, amount, event) {
        if (cleverapps.meta.selectedLocationId() === locationId) {
            cleverapps.lives.give(amount);
        } else {
            const lives = new cleverapps.Lives(cleverapps.meta.getLocationMeta(locationId).locationConfig);
            lives.load();
            lives.give(amount);
            lives.stopRegenerateTimeout();
        }

        if (event) {
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.EARN.LIVES}-${locationId}_${event}`, { value: amount });
        }
    },

    ListActiveOwnLivesLocationIds: function () {
        return cleverapps.meta.listActiveLocations().filter((locationId) => cleverapps.meta.getLocationMeta(locationId).locationConfig.withOwnLives);
    },

    GetActiveOwnLivesLocationId: function () {
        return this.ListActiveOwnLivesLocationIds()[0];
    }
};

SyncAdapters.lives = {
    beforeUpdate: () => {
        LivesHelper.GetMainInstance().beforeUpdate();

        if (cleverapps.lives !== LivesHelper.GetMainInstance()) {
            cleverapps.lives.beforeUpdate();
        }
    },
    getInfo: () => LivesHelper.GetMainInstance().getInfo(),
    updateInfo: (serverData) => LivesHelper.GetMainInstance().updateInfo(serverData, true)
};
